module.exports = __webpack_public_path__ + "static/profile-fcd67e8730eb3fef6b407209177790e0.png";